module.exports = __webpack_public_path__ + "assets/images/bank.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bank.png
// module id = 245
// module chunks = 1